module.exports = __webpack_public_path__ + "assets/img/loading3.5690999d.gif";